import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import styles from "./LabeledIcon.module.scss";
export const LabeledIcon = ({ label, Icon, iconClassName, dataTestId }) => {
    return (_jsxs("div", { className: styles.container, ...(dataTestId && { "data-testid": dataTestId }), children: [_jsx(Icon, { className: classNames(styles.icon, iconClassName) }), _jsx("div", { className: styles.text, children: label })] }));
};
//# sourceMappingURL=LabeledIcon.js.map